import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaAngleDown } from 'react-icons/fa';

import TappableCard from '../common/TappableCard';
import { BoldText } from '../common/Text';
import filterIcon from '../../images/Claims-Page/filterIcon.svg';
import userIcon from '../../images/Claims-Page/User.svg';
import arrowDown from '../../images/common/arrow-down.svg';

const OuterContainer = styled(TappableCard)`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background: #ffffff;
  border: 1px solid #e6e9ec;
  border-radius: 18px;
  box-shadow: none !important;
`;

const UserImage = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 0.375rem;
`;

const UserText = styled.p`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin-right: 0.5rem;
  font-weight: 500;
`;

// const ConsultationUser = ({ icon, text, onTap }) => (
//   <OuterContainer onTap={onTap}>
//     <>
//       <UserImage src={userIcon} />
//       <UserText>{text || 'Self'}</UserText>
//       <img src={arrowDown} alt="select patient" />
//     </>
//   </OuterContainer>
// );

// ConsultationUser.propTypes = {
//   icon: PropTypes.string,
//   text: PropTypes.string,
//   onTap: PropTypes.func,
// };

// export default ConsultationUser;
const ConsultationUser = ({ icon, text, onTap }) => (
  <OuterContainer onTap={onTap}>
    <>
      <UserImage src={filterIcon} />
      <UserText>{text}</UserText>
      {/* <img src={arrowDown} alt="select patient" /> */}
    </>
  </OuterContainer>
);

ConsultationUser.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  onTap: PropTypes.func,
};

export default ConsultationUser;
